import { render, staticRenderFns } from "./DossierInboundsDocuments.vue?vue&type=template&id=c57cab34&scoped=true&"
import script from "./DossierInboundsDocuments.vue?vue&type=script&lang=ts&"
export * from "./DossierInboundsDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./DossierInboundsDocuments.vue?vue&type=style&index=0&id=c57cab34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57cab34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable,VIcon})
